import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../component/Navbar/Navbar";

const APP_PROTOCOL = "zerotypingai://signup-success";

const WindowsIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M3 5.5 11 4v8H3V5.5zM12 3.85 21 2.5V12h-9V3.85zM3 13h8v7.15L3 19V13zm9 0h9v8.5L12 20.15V13z" />
  </svg>
);

const AppleIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M16.365 1.43c0 1.14-.43 2.18-1.13 2.96-.78.85-2 1.5-3.03 1.42-.13-1.07.46-2.2 1.16-2.97.78-.86 2.1-1.48 3-1.41zM20.5 17.27c-.55 1.27-.82 1.84-1.54 2.97-1 1.57-2.41 3.52-4.16 3.53-1.55.02-1.95-1.01-4.06-1-2.1.01-2.55 1.02-4.1 1-1.74-.02-3.08-1.78-4.08-3.35-2.8-4.37-3.1-9.5-1.37-12.23 1.23-1.94 3.17-3.08 4.99-3.08 1.85 0 3.01 1.01 4.55 1.01 1.49 0 2.4-1.02 4.54-1.02 1.62 0 3.34.88 4.56 2.4-4.01 2.2-3.36 7.94.67 8.77z" />
  </svg>
);

const detectPlatform = () => {
  if (typeof navigator === "undefined") return "other";
  const ua =
    navigator.userAgentData?.platform ||
    navigator.platform ||
    navigator.userAgent ||
    "";
  if (/mac|iphone|ipad|ipod/i.test(ua)) return "mac";
  if (/win/i.test(ua)) return "windows";
  return "other";
};

const SignupSuccess = () => {
  const [platform, setPlatform] = useState("other");

  useEffect(() => {
    setPlatform(detectPlatform());
  }, []);

  const handleReturnToApp = () => {
    window.location.href = APP_PROTOCOL;
  };

  const isMac = platform === "mac";
  const PlatformIcon = isMac ? AppleIcon : WindowsIcon;

  return (
    <div className="bg-white md:p-4 p-3 max-w-screen-2xl mx-auto min-h-screen flex flex-col">
      <Navbar />

      <div className="relative mt-6 md:mt-0 rounded-2xl overflow-hidden border border-[#3AB1F626] flex-1 flex flex-col">
        <div className="absolute inset-0 bg-[#D8EFFD] opacity-50 pointer-events-none" />

        <div
          className="absolute pointer-events-none rounded-full"
          style={{
            width: "min(650px, 75vw)",
            height: "min(650px, 75vw)",
            left: "-15%",
            bottom: "-25%",
            background: "#3AB1F6",
            opacity: 0.65,
            filter: "blur(140px)",
            WebkitFilter: "blur(140px)",
          }}
        />
        <div
          className="absolute pointer-events-none rounded-full"
          style={{
            width: "min(650px, 75vw)",
            height: "min(650px, 75vw)",
            right: "-15%",
            bottom: "-25%",
            background: "#3AB1F6",
            opacity: 0.65,
            filter: "blur(140px)",
            WebkitFilter: "blur(140px)",
          }}
        />

        <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-4 sm:px-6 md:px-8 py-12 sm:py-16 md:py-20">
          <h1 className="font-inter font-semibold text-black text-center text-[22px] sm:text-[28px] md:text-[34px] lg:text-[38px] leading-tight tracking-[-0.03em] mb-3 px-2">
            Click Below To Finish Login
          </h1>
          <p className="font-inter font-normal text-[#00000080] text-center text-[14px] sm:text-[16px] md:text-[18px] lg:text-[19.44px] leading-[150%] tracking-[-0.03em] max-w-[584px] mb-6 sm:mb-8 px-2">
            Press the below button to successfully log back into Zero Typing AI.
          </p>

          <button
            type="button"
            onClick={handleReturnToApp}
            style={{
              background: "linear-gradient(90deg, #3AB1F6 0%, #407BFF 100%)",
              border: "1px solid #9797970A",
            }}
            className="hover:opacity-90 transition-opacity duration-300 ease-in-out text-white rounded-full flex items-center w-[200px] sm:w-[232px] h-[52px] sm:h-[60px] pl-[7px] sm:pl-[9px] pr-[28px] sm:pr-[41px] py-[7px] sm:py-[9px] gap-[16px] sm:gap-[22px] shadow-md"
          >
            <span className="bg-white text-[#3AB1F6] rounded-full w-[38px] h-[38px] sm:w-[42px] sm:h-[42px] flex items-center justify-center shrink-0">
              <PlatformIcon />
            </span>
            <span className="font-inter font-semibold text-[14px] sm:text-[16px] whitespace-nowrap">
              Return to App
            </span>
          </button>

          <p className="font-inter text-[#00000080] text-center text-[13px] sm:text-[14px] mt-5 sm:mt-6">
            Don't have the app installed?{" "}
            <Link
              to="/windows"
              className="text-[#3AB1F6] font-medium hover:underline"
            >
              Download here
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignupSuccess;
